import script from "./AppTreeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTreeSelect.vue?vue&type=script&setup=true&lang=js"

import "./AppTreeSelect.vue?vue&type=style&index=0&id=0484d4f0&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0484d4f0"]])

export default __exports__